module.exports = __webpack_public_path__ + "img/rebus3-6.0719a450.jpg";